import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { getAvatares } from '../../../constants/avatarIcons';
import { StyledBtnLeft, StyledBtnRight } from '../ScrollAvatar/style';

import {
  MainAvatarEdition,
  StyledAvatarEdition,
  AvatarItem,
  StyledIcon
} from './styleSelectAvatar';

const isActiveAvatar = (id, idState) => id === idState;

const SelectAvatar = ({ className, getAvatar }) => {
  const avatarContainer = useRef();
  const avatares = getAvatares();
  const [idAvatar, SetIdAvatar] = useState(null);

  return (
    <React.Fragment>
      <StyledBtnLeft
        onClick={() => {
          avatarContainer.current.scrollLeft -= 270;
          return null;
        }}
      />
      <MainAvatarEdition className={className} innerRef={avatarContainer}>
        <StyledAvatarEdition numElements={avatares.length}>
          {avatares.map(avatar => (
            <AvatarItem
              onClick={() => {
                getAvatar(avatar.id);
                SetIdAvatar(avatar.id);
              }}
              key={avatar.id}
              isActive={isActiveAvatar(avatar.id, idAvatar)}
            >
              <StyledIcon svg={avatar.img} />
            </AvatarItem>
          ))}
        </StyledAvatarEdition>
      </MainAvatarEdition>
      <StyledBtnRight
        onClick={() => {
          avatarContainer.current.scrollLeft += 270;
          return null;
        }}
      />
    </React.Fragment>
  );
};

SelectAvatar.propTypes = {
  className: PropTypes.string,
  getAvatar: PropTypes.func
};

export default SelectAvatar;
